import {path} from 'ramda'

const databaseId = path(['databaseId'])

export default function changePayload({command}, {person, assignedUntil}) {
  const body = JSON.parse(command)
  const commandBody = {
    ...body,
    assignedUntil: assignedUntil.nextValue,
    personDatabaseId: databaseId(person),
  }
  return {
    command: JSON.stringify(commandBody),
  }
}
